import React from 'react';
import FormInput from "../FormInput";
import * as Yup from 'yup';
import Utils from "../../common/Utils";
import AppVariables from '../../common/AppVariables';
import {ErrorMessage} from "formik";
import {CommandAgricEndpoints as VirtualCredit, CommandAgricEndpoints} from "../../common/ProxyEndpoints";
import TTLProxy from "../../common/TTLAsyncProxy";

const createNetworkProvider = ({ id , name , logo }) =>  ({
    id,
    name,
    logo,
    roles: ["admin", "fbo" , "farmer" ],
    initialValues: ({ farmerData ,  ...other  }) => {

        return {
            txn_operator: id,
            payment_method: "mobile",
            txn_phone:  Utils.fixPhone(farmerData.farmer ? farmerData.farmer.instance.phone : farmerData.phone ,  farmerData['phone-region'])
        }
    },
    validationSchema: {
        txn_phone: Yup.string().label("Transaction Phone No").required(),
        txn_operator: Yup.string().optional().label("Network Operator")
    },
    customValidation: values => {

        let errors = {};
        if(!Utils.validatePhoneNumber(values.txn_phone) || !values.txn_phone.startsWith(AppVariables.CountryDialingCode)){
            errors.txn_phone = "Invalid transaction phone number";
        }

        return errors;
    },
    getPaymentDetails: values => ([
        {
            title: "Phone No.",
            value: values.txn_phone
        },
    ]),
    component: ({ logo }) => {

        return <React.Fragment>

            <FormInput  name="txn_phone"
                        type="text"
                        title="Payment Mobile No."
                        required={true}
                        icon="fa fa-phone"
                        showPrompt={true}
                        placeholder={`Enter payment phone no. eg. ${AppVariables.CountryDialingCode}71812289`}/>

        </React.Fragment>
    }

});

const PaymentMethods = [
    createNetworkProvider({ id: 'mtn' , name: 'MTN' , logo: '/img/networks/mtn_wallet_icon.png' }),
    createNetworkProvider({ id: 'moov' , name: 'Moov' , logo: '/img/networks/moov_wallet_icon.png' }),
    {
        id: "virtual-credit",
        name: "Wallet",
        logo: "/img/networks/credit_wallet_icon.png",
        roles: [ "admin", "fbo" , "farmer" ],
        behaviours: {

            booking: {
                enabled: true,
                renderComponent: true,
                initialValues: null // Set to null to use form initial values of payment
            }

        },
        initialValues: ({ farmerData ,  ...other  }) => {

            return {
                txn_operator: "Virtual-Credit",
                payment_method: "virtual-credit",
                txn_phone:  Utils.fixPhone(farmerData.farmer ? farmerData.farmer.instance.phone : farmerData.phone ,  farmerData['phone-region'])
            }
        },
        validationSchema: {
            txn_phone: Yup.string().label("Registered wallet phone no.").required()
        },
        customValidation: async (values,wizardState) => {

            const { farmerData , serviceData , requestCost } = wizardState;
            const { txn_phone } = values;

            let errors = {};

            const proxy = TTLProxy.getInstance();
            if(!Utils.validatePhoneNumber(values.txn_phone) || !values.txn_phone.startsWith(AppVariables.CountryDialingCode)){
                errors.txn_phone = "Invalid phone number";
            }

            try {

                const response = await proxy.processRequest(farmerData.farmer ? VirtualCredit.queryFarmerStatus(farmerData.farmer.instance.id) :
                    VirtualCredit.queryFarmerStatusWithPhone(txn_phone));

                const { services } = response.getPayload();
                const svc = services.find(x => x.service_id === serviceData.service.value);
                if(!svc){
                    errors.apiResult = "Failed: Service not supported or farmer is not eligible for selected service";
                }
                else if(svc.amount < Number(requestCost.cost)){
                    errors.apiResult = "Sorry, not enough funds available to complete transaction";
                }

            }
            catch (e) {

                if(e.response.status === 404){
                    errors.apiResult = "Failed: Farmer not eligible for selected payment option";
                }
                else{
                    errors.apiResult = Utils.getResponseError(e);
                }

            }

            if(Object.keys(errors).length > 0)
                throw errors;

        },
        getPaymentDetails: values => ([
            {
                title: "Phone No.",
                value: values.txn_phone
            }
        ]),
        component: ({ logo , form: { errors } }  ) => {

            return <React.Fragment>

                <FormInput  name="txn_phone"
                            type="text"
                            title="Wallet phone no."
                            required={true}
                            disabled
                            icon="fa fa-phone"
                            showPrompt={true}
                            placeholder={`Enter wallet registered phone no. eg. ${AppVariables.CountryDialingCode}55512289`}/>

                {errors.apiResult && (<div className="error-label">{errors.apiResult}</div>)}

            </React.Fragment>
        }
    }
];

export default PaymentMethods;



// WEBPACK FOOTER //
// ./src/components/TractorRequestBuilder/PaymentMethods.js